import { Alert } from 'antd';
import StyledAlert from './styles/alert.style';

const AtsAlert = StyledAlert(Alert);

export default AtsAlert;
